// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3uMmI","header":"ReportDetails_header__1vnap","title":"ReportDetails_title__3ATVo","left":"ReportDetails_left__3OevX"};